import { Link, useLocation } from 'react-router-dom'
import { Button } from '@brent/core-ui/ui'
import { useAuth } from '@/hooks/useAuth'
import { Separator } from '@brent/core-ui/ui'

interface NavigationProps {
  mobile?: boolean
  onNavigate?: () => void
}

export default function Navigation({ mobile = false, onNavigate }: NavigationProps) {
  const location = useLocation()
  const { isAuthenticated, logout, user, hasGroup } = useAuth()
  // Surveys and voting are for playing members only (the API enforces it too)
  const isMember = hasGroup('member')

  const isActive = (path: string) => location.pathname === path

  const handleSignOut = () => {
    logout()
    onNavigate?.()
  }

  const handleNavigate = () => {
    onNavigate?.()
  }

  if (mobile) {
    return (
      <nav className="flex flex-col gap-2">
        {isAuthenticated ? (
          <>
            {user && (
              <>
                <div className="px-2 py-3">
                  <p className="text-sm font-medium">{user.name || 'Member'}</p>
                  <p className="text-xs text-muted-foreground">{user.email}</p>
                </div>
                <Separator />
              </>
            )}
            <Button
              asChild
              variant={isActive('/suggestions') ? 'default' : 'ghost'}
              className="w-full justify-start"
              onClick={handleNavigate}
            >
              <Link to="/suggestions">My Suggestions</Link>
            </Button>
            {isMember && (
              <>
                <Button
                  asChild
                  variant={isActive('/voting') ? 'default' : 'ghost'}
                  className="w-full justify-start"
                  onClick={handleNavigate}
                >
                  <Link to="/voting">Voting</Link>
                </Button>
                <Button
                  asChild
                  variant={isActive('/survey') ? 'default' : 'ghost'}
                  className="w-full justify-start"
                  onClick={handleNavigate}
                >
                  <Link to="/survey">Survey</Link>
                </Button>
              </>
            )}
            <Button variant="ghost" onClick={handleSignOut} className="w-full justify-start">
              Sign Out
            </Button>
          </>
        ) : (
          <Button
            asChild
            variant={isActive('/auth') ? 'default' : 'ghost'}
            className="w-full justify-start"
            onClick={handleNavigate}
          >
            <Link to="/auth">Sign In</Link>
          </Button>
        )}
      </nav>
    )
  }

  return (
    <nav className="flex items-center gap-2">
      {isAuthenticated ? (
        <>
          {user && (
            <span className="text-sm text-muted-foreground mr-2 hidden lg:inline">
              {user.name || user.email}
            </span>
          )}
          <Button asChild variant={isActive('/suggestions') ? 'default' : 'ghost'}>
            <Link to="/suggestions">My Suggestions</Link>
          </Button>
          {isMember && (
            <>
              <Button asChild variant={isActive('/voting') ? 'default' : 'ghost'}>
                <Link to="/voting">Voting</Link>
              </Button>
              <Button asChild variant={isActive('/survey') ? 'default' : 'ghost'}>
                <Link to="/survey">Survey</Link>
              </Button>
            </>
          )}
          <Button variant="ghost" onClick={handleSignOut}>
            Sign Out
          </Button>
        </>
      ) : (
        <Button asChild variant={isActive('/auth') ? 'default' : 'ghost'}>
          <Link to="/auth">Sign In</Link>
        </Button>
      )}
    </nav>
  )
}
